import homepage from './components/pages/homepage';
import article from './components/pages/article';
import news from './components/pages/news';
import pages from './components/pages/pages';
import sportselect from './components/pages/sportselect';
import sportselectdetail from './components/pages/sportselectdetail';
import sportsschedule from './components/pages/sportsschedule';
import match from './components/pages/match';
import staticweb from './components/pages/static';
import teilnehmer from './components/pages/teilnehmer';
import teilnehmerlist from './components/pages/teilnehmerlist';
import anmeldung from './components/pages/anmeldung';
import ausschreibung from './components/pages/ausschreibung';


const routes = [
  { path: '/', component: homepage, meta: { bodyClass: 'home' } },
  { path: '/news', component: news, meta: { bodyClass: 'news' } },
  { path: '/news/:id/:en', component: article, meta: { bodyClass: 'news' } },
  { path: '/pages/:id/:en', component: pages, meta: { bodyClass: 'article' } },
  { path: '/sport', component: sportselect, meta: { bodyClass: 'sport' } },
  { path: '/sport/:id', component: sportselectdetail, meta: { bodyClass: 'sport' } },
  { path: '/sport/shedule/:id', component: sportsschedule, meta: { bodyClass: 'sport' } },
  { path: '/sport/shedule/match/:id', component: match, meta: { bodyClass: 'sport' } },
  { path: '/staticweb/:id', component: staticweb, meta: { bodyClass: 'sport' } },
  { path: '/teilnehmer/:id', component: teilnehmer, meta: { bodyClass: 'sport' } },
  { path: '/teilnehmer/', component: teilnehmerlist, meta: { bodyClass: 'sport' } },
  { path: '/anmeldung', component: anmeldung, meta: { bodyClass: 'sport' } },
  { path: '/ausschreibung', component: ausschreibung, meta: { bodyClass: 'sport' } }
];


export default routes;
